import 'core-js/stable';
import 'regenerator-runtime/runtime';
import '../components/images/Sprits/icons';
import '../assets/global-style/style.scss';

(function () {
	console.log('global init');
})();
